/** @returns {*} the first element of an Array or NodeList */
export const first = list => list == null || list.length === 0 ? undefined : list[0];

/** @returns {*} the last element of an Array or NodeList */
export const last = list => list == null || list.length === 0 ? undefined : list[list.length - 1];